export const Weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;
export type Weekday = typeof Weekdays[number];

export const getWeekday = (date: Date): Weekday =>
    date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase() as Weekday;
export const getCurrentWeekday = () => getWeekday(new Date());
